var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00488 7.0791V5.0791C4.00488 3.75302 4.53167 2.48125 5.46935 1.54357C6.40703 0.605886 7.6788 0.0791016 9.00488 0.0791016C10.331 0.0791016 11.6027 0.605886 12.5404 1.54357C13.4781 2.48125 14.0049 3.75302 14.0049 5.0791V7.0791H17.0049C17.2701 7.0791 17.5245 7.18446 17.712 7.37199C17.8995 7.55953 18.0049 7.81389 18.0049 8.0791V20.0791C18.0049 20.3443 17.8995 20.5987 17.712 20.7862C17.5245 20.9737 17.2701 21.0791 17.0049 21.0791H1.00488C0.739666 21.0791 0.485312 20.9737 0.297776 20.7862C0.11024 20.5987 0.00488281 20.3443 0.00488281 20.0791V8.0791C0.00488281 7.81389 0.11024 7.55953 0.297776 7.37199C0.485312 7.18446 0.739666 7.0791 1.00488 7.0791H4.00488ZM4.00488 9.0791H2.00488V19.0791H16.0049V9.0791H14.0049V11.0791H12.0049V9.0791H6.00488V11.0791H4.00488V9.0791ZM6.00488 7.0791H12.0049V5.0791C12.0049 4.28345 11.6888 3.52039 11.1262 2.95778C10.5636 2.39517 9.80053 2.0791 9.00488 2.0791C8.20923 2.0791 7.44617 2.39517 6.88356 2.95778C6.32095 3.52039 6.00488 4.28345 6.00488 5.0791V7.0791Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.128b4618ab79ad90b36fe261ddf11fcc.svg";
export { ForwardRef as ReactComponent };